import { Tooltip } from 'antd';
import { observer } from 'mobx-react-lite';
import { type ComponentProps } from 'react';

import { Logo } from '../../Logo/Logo';
import { ReactComponent as CowboyHatNavinaLogo } from './CowboyHatNavinaLogo.svg';

export const FourthOfJulyLogo = observer(function FourthOfJulyLogo(props: ComponentProps<typeof Logo>) {
	return (
		<Tooltip
			{...{
				title: 'Happy Fourth of July!',
				placement: 'right',
				children: <Logo {...{ children: <CowboyHatNavinaLogo />, ...props }} />,
			}}
		/>
	);
});
